import React, { useId } from 'react';

/**
 * 공통 시간 선택 컴포넌트 (type="time" 기반)
 * @param {string} value - 선택된 시간 문자열 (예: 'HH:mm')
 * @param {function(string)} onChange - 시간 선택 시 호출 (시간 문자열 전달)
 * @param {string} [id] - input id (미지정 시 자동 생성)
 * @param {string} [className] - 래퍼 div className
 * @param {string} [inputClassName=''] - input className
 * @param {string} [min] - 최소 시간 (예: '09:00')
 * @param {string} [max] - 최대 시간 (예: '18:00')
 * @param {boolean} [showIcon=true] - 시계 아이콘 표시
 */
function Timepicker(props) {
  const {
    value = '',
    onChange,
    id: idProp,
    className = '',
    inputClassName = '',
    min,
    max,
    showIcon = true,
  } = props;

  const generatedId = useId();
  const id = idProp ?? `timepicker-${generatedId.replace(/:/g, '')}`;

  return (
    <div className={`group relative ${className}`}>
      <input
        type="time"
        id={id}
        className={`w-full rounded-lg border border-slate-200 bg-slate-50 px-4 transition-all outline-none text-slate-900 focus:border-[#FF6B00] focus:ring-2 focus:ring-[#FF6B00]/50 cursor-pointer select-none ${showIcon ? 'pr-10' : ''} ${inputClassName}`}
        value={value}
        min={min}
        max={max}
        onChange={(e) => onChange?.(e.target.value)}
        onClick={(e) => e.target.showPicker?.()}
        onKeyDown={(e) => e.preventDefault()}
      />
      {showIcon && (
        <span
          className="material-symbols-outlined pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 transition-colors group-focus-within:text-[#FF6B00]"
          aria-hidden
        >
          schedule
        </span>
      )}
    </div>
  );
}

export default Timepicker;
